import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function CookiesPolicy() {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-grow bg-white">
        <div className="max-w-4xl mx-auto px-6 py-16 md:py-24">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-8">
            Política de Cookies
          </h1>
          
          <div className="prose prose-lg max-w-none text-gray-700 space-y-8">
            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">¿Qué son las cookies?</h2>
              <p>
                Las cookies son pequeños archivos de texto que se almacenan en su dispositivo cuando visita un sitio web. Se utilizan ampliamente para hacer que los sitios web funcionen de manera más eficiente y proporcionen información a los propietarios del sitio.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">¿Cómo utilizamos las cookies?</h2>
              <p>
                En David Rio Web, utilizamos cookies para mejorar su experiencia de navegación y entender cómo interactúa con nuestro sitio web. Las cookies nos ayudan a:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Recordar sus preferencias de idioma</li>
                <li>Analizar el tráfico del sitio web</li>
                <li>Mejorar el rendimiento y la funcionalidad del sitio</li>
                <li>Personalizar su experiencia de usuario</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">Tipos de cookies que utilizamos</h2>
              
              <div className="space-y-6">
                <div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-2">Cookies estrictamente necesarias</h3>
                  <p>
                    Estas cookies son esenciales para que el sitio web funcione correctamente. Permiten la navegación básica y el acceso a áreas seguras del sitio. Sin estas cookies, el sitio no puede funcionar adecuadamente.
                  </p>
                </div>

                <div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-2">Cookies de preferencias</h3>
                  <p>
                    Estas cookies permiten que el sitio web recuerde información que cambia la forma en que se comporta o se ve el sitio, como su idioma preferido o la región en la que se encuentra.
                  </p>
                </div>

                <div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-2">Cookies de análisis</h3>
                  <p>
                    Estas cookies nos ayudan a entender cómo los visitantes interactúan con nuestro sitio web, recopilando y reportando información de forma anónima. Esto nos permite mejorar continuamente nuestro sitio.
                  </p>
                </div>

                <div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-2">Cookies de marketing</h3>
                  <p>
                    Estas cookies se utilizan para rastrear a los visitantes en los sitios web. La intención es mostrar anuncios que sean relevantes y atractivos para el usuario individual.
                  </p>
                </div>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">Cookies de terceros</h2>
              <p>
                Algunos de nuestros socios pueden establecer cookies en su dispositivo cuando visita nuestro sitio. Estos terceros pueden incluir:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Servicios de análisis web (como Google Analytics)</li>
                <li>Plataformas de redes sociales</li>
                <li>Proveedores de contenido integrado</li>
              </ul>
              <p className="mt-4">
                No tenemos control sobre estas cookies de terceros. Le recomendamos que consulte las políticas de privacidad de estos terceros para obtener más información.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">Gestión de cookies</h2>
              <p>
                Puede controlar y gestionar las cookies de varias maneras:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>
                  <strong>Configuración del navegador:</strong> La mayoría de los navegadores le permiten rechazar o aceptar cookies. Puede ajustar la configuración de su navegador para bloquear cookies o alertarle cuando se envíe una cookie.
                </li>
                <li>
                  <strong>Eliminar cookies:</strong> Puede eliminar las cookies que ya están en su dispositivo a través de la configuración de su navegador.
                </li>
                <li>
                  <strong>Herramientas de terceros:</strong> Existen herramientas en línea que le permiten gestionar cookies de múltiples sitios web.
                </li>
              </ul>
              <p className="mt-4">
                Tenga en cuenta que si bloquea o elimina cookies, algunas funciones de nuestro sitio web pueden no funcionar correctamente.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">Cómo deshabilitar cookies en los navegadores principales</h2>
              <ul className="list-disc pl-6 space-y-2">
                <li><strong>Google Chrome:</strong> Configuración → Privacidad y seguridad → Cookies y otros datos de sitios</li>
                <li><strong>Mozilla Firefox:</strong> Opciones → Privacidad y seguridad → Cookies y datos del sitio</li>
                <li><strong>Safari:</strong> Preferencias → Privacidad → Cookies y datos de sitios web</li>
                <li><strong>Microsoft Edge:</strong> Configuración → Cookies y permisos del sitio → Cookies y datos del sitio</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">Actualizaciones de esta política</h2>
              <p>
                Podemos actualizar esta Política de Cookies periódicamente para reflejar cambios en nuestras prácticas o por otras razones operativas, legales o reglamentarias. Le recomendamos que revise esta página regularmente para estar informado sobre cómo utilizamos las cookies.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">Contacto</h2>
              <p>
                Si tiene preguntas sobre nuestra Política de Cookies, puede contactarnos a través del formulario de contacto en nuestro sitio web.
              </p>
              <p className="mt-4">
                <strong>Última actualización:</strong> {new Date().toLocaleDateString('es-ES', { year: 'numeric', month: 'long', day: 'numeric' })}
              </p>
            </section>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}